import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import ToggleModalSkeleton from '../../components/Skeletons/ToggleModalSkeleton';

const ToggleUserActive = ({ toggleUserModal, loading, deleteUserData, handleToggleModalClose, handleUserToggle }) => {
	const { t } = useTranslation();
	const name = deleteUserData.name;
	return (
		<Modal show={toggleUserModal}>
			<ModalHeading heading={deleteUserData.active ? t('screens.users.toggleTitleDeactivate', { name }) : t('screens.users.toggleTitleActivate', { name })} />
			{loading ? (
				<ToggleModalSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }}>
					<InputsSection style={{ width: '34rem' }}>
						{deleteUserData.active ? (
							<p className='primaryText'>{t('screens.users.toggleDeactivatePrompt', { name })}</p>
						) : (
							<p className='primaryText'>{t('screens.users.toggleActivatePrompt', { name })}</p>
						)}
					</InputsSection>
					<ModalButtons
						submitButtonLabel={deleteUserData.active ? t('screens.users.toggleBtnDeactivate') : t('screens.users.toggleBtnActivate')}
						onSubmit={(e) => handleUserToggle(e, deleteUserData._id, deleteUserData.active)}
						cancelButtonLabel={t('screens.users.cancel')}
						onCancel={handleToggleModalClose}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default ToggleUserActive;
